import { allowed, holdsPermission, type Resource } from './permissions.js';
import { useCurrentUser } from './use-current-user.js';

/**
 * Whether to show this.
 *
 * With a resource it asks the question the API asks — may this user do this, to this. Without one
 * it asks whether they hold the permission anywhere, which is the question a persona link asks: a
 * supervisor of one team should see the supervision area, and the link names no team.
 *
 * Either way the answer is **presentation**. The API authorises every call, a hidden control is not
 * a protected one, and a 403 that gets through is a state to display. Nothing in the interface may
 * be the only thing standing between a user and an action.
 */
export function usePermission(permission: string, resource?: Resource): boolean {
  const { data: me } = useCurrentUser();
  if (me === undefined) {
    // Nothing is shown until the permissions are known. The alternative — showing it and taking it
    // away — is worse than a moment of less.
    return false;
  }
  return resource === undefined
    ? holdsPermission(me, permission)
    : allowed(me, permission, resource);
}
